import PropTypes from 'prop-types';

import icons from 'icons';
import { isUrl, logger } from 'utils';

type IconProps = {
  className?: string;
  nameOrUrl: string;
  alt?: string;
};

export const Icon = ({ className, nameOrUrl, alt }: IconProps) => {
  if (isUrl(nameOrUrl)) {
    return <img className={className} src={nameOrUrl} alt={alt} />;
  }
  const ResolvedIcon = icons[nameOrUrl];
  if (!ResolvedIcon) {
    logger.warn('Icon not found, please check if AppFrame has this icon exported!');
    return null;
  }
  return <ResolvedIcon className={className} />;
};

Icon.propTypes = {
  className: PropTypes.string,
  nameOrUrl: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default Icon;
